
<div class="d-flex mt16">
  <div class="w100 px16">
    <h3 i18n>Registration of organizations</h3>
    <form
      class="d-flex flex-column"
      [formGroup]="organizationGroup">
      <mat-form-field appearance="outline">
        <mat-label i18n>Organization name</mat-label>
        <input required matInput formControlName="name" type="text">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n>Contact manager name</mat-label>
        <input required matInput formControlName="contact_manager_name" type="text">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n>Contact manager phone</mat-label>
        <input required matInput type="text" formControlName="contact_manager_phone">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n>Contact manager email</mat-label>
        <input required matInput type="text"  formControlName="contact_manager_email">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n>Ip address</mat-label>
        <input required matInput type="text"  formControlName="ipAddress">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n>Address</mat-label>
        <input required matInput type="text"  formControlName="address">
      </mat-form-field>


      <mat-form-field appearance="outline">
        <mat-label i18n>internalIp</mat-label>
        <input required matInput type="text"  formControlName="internalIp">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n>License server auth token</mat-label>
        <input required matInput type="text"  formControlName="license_server_auth_token">
      </mat-form-field>

    </form>

    <div class="d-flex px16">
      <div class="f-gr-1"></div>
      <button
        [disabled]="organizationGroup.invalid"
        mat-raised-button color="primary" (click)="createOrganization()">
        <span i18n>Add organization</span>
      </button>
    </div>
  </div>

</div>



